import { $color_grey_5, $color_brand_bg_active } from '../pebbleGlobalToken/color.js';

/**
 * 开关-文本行高
 * @description enDesc: -
 * @description type: Font
 * @description value: 1.4285714285714286
 */
var $switch_line_height = 1.4285714285714286;

/**
 * 开关-第三级文本色一般用于描述性文本，例如表单的中的补充说明文本、列表的描述性文本等场景。
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-5
 */
var $switch_color_text_tertiary = $color_grey_5;

/**
 * 开关-展开时颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_bg_active
 */
var $switch_color_open_active = $color_brand_bg_active;

export { $switch_color_open_active, $switch_color_text_tertiary, $switch_line_height };
